angular.module('ui.bootstrap', [
  'ui.bootstrap.dropdown',
  'ui.bootstrap.carousel',
  'ui.bootstrap.datepicker',
  'ui.bootstrap.modal'
]);
